namespace RioERP.Invoices {
    export namespace InvoiceNumberFormatService {
        export const baseUrl = 'Invoices/InvoiceNumberFormat';

        export declare function Create(request: Serenity.SaveRequest<InvoiceNumberFormatRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<InvoiceNumberFormatRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<InvoiceNumberFormatRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<InvoiceNumberFormatRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Invoices/InvoiceNumberFormat/Create",
            Update = "Invoices/InvoiceNumberFormat/Update",
            Delete = "Invoices/InvoiceNumberFormat/Delete",
            Retrieve = "Invoices/InvoiceNumberFormat/Retrieve",
            List = "Invoices/InvoiceNumberFormat/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>InvoiceNumberFormatService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
